<div class="add-value-list">
  <div class="add-value-list__title">
    <app-section-title
      [title]="title"
      [titleTooltip]="titleTooltip"
      [message]="messageTooltip"
      [isInnerHTML]="true"
      [tooltipContentRef]="tooltipContentRef"
    ></app-section-title>
  </div>
  <div class="add-value-list__content">
    <div class="add-value-list__content--list">
      <ng-container *ngTemplateOutlet="valueListViewTemplate"></ng-container>
    </div>
    @if (displayAddButton()) {
      <div class="add-value-list__content--action">
        <app-button-add (clickEmitter)="handleAddAction()" [title]="buttonText" [isDisabled]="handleIsDisabledButton()">
        </app-button-add>
        @if (epValidatorField) {
          <div class="error-field">
            <app-validator-error-message
              [epValidator]="epValidator"
              [index]="0"
              [fieldName]="epValidatorField"
            ></app-validator-error-message>
          </div>
        }
      </div>
    }
    @if (showAddValueViewTemplate) {
      <div class="add-value-list__content--inputs">
        <ng-container *ngTemplateOutlet="addValueViewTemplate"></ng-container>
      </div>
    }
  </div>
</div>
